import { useContext } from 'react'
import { DataContext } from './DataContext'

// For components that also render outside a Document (e.g. the editor in a form view), where
// useDataContext would throw.
export const useOptionalDataContext = () => useContext(DataContext)
